import { isColorValid } from './isColorValid';

export const colorHandler = (color: string, defaultColor: string, onInvalidCallback?: Function): string => {
  if (!isColorValid(color)) {
    if (onInvalidCallback) {
      onInvalidCallback();
    }
    return defaultColor;
  }

  return color;
};
